import { Box } from '@mui/material';
import DataCard from 'components/data-card/data-card.component';
import { useSMSTotalsSearch } from 'pages/analytics/sms-reports/sms-reports-landing/sms-reports-search/sms-reports-search.hooks';
import { useTranslation } from 'react-i18next';

const MarketingSummaryHeader = () => {
  const { t } = useTranslation();
  const { data, isFetching } = useSMSTotalsSearch('MARKETING');

  return (
    <Box
      display="grid"
      gridTemplateColumns={{ xs: 'repeat(1, 1fr)', lg: 'repeat(2, 1fr)' }}
      gap={2}
    >
      <DataCard
        title={t(
          'page.reportAndAnalytics.smsReports.sections.marketing.summaryHeader.marketingSMSTotal.title',
        )}
        value={data?.smsTotal ?? 0}
        valueType="number"
        description={t(
          'page.reportAndAnalytics.smsReports.sections.marketing.summaryHeader.marketingSMSTotal.description',
        )}
        loading={isFetching}
        data-testid="MarketingSMSTotal.Card"
      />
      <DataCard
        title={t(
          'page.reportAndAnalytics.smsReports.sections.marketing.summaryHeader.marketingSMSSegmentTotal.title',
        )}
        value={data?.segmentsTotal ?? 0}
        valueType="number"
        description={t(
          'page.reportAndAnalytics.smsReports.sections.marketing.summaryHeader.marketingSMSSegmentTotal.description',
        )}
        loading={isFetching}
        data-testid="MarketingSMSSegmentTotal.Card"
      />
    </Box>
  );
};
export default MarketingSummaryHeader;
